export default __webpack_public_path__ + "assets/icon-widgets.06d5adca.webp";